import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';
import { Paragraph } from '@uncinc/react-drupal-core';

import { WysiwygField } from '../../../components';

// import './style.scss';

const ParagraphGrowthPath = ({ entity, className }) => {
  return (
    <div className={classNames('Paragraph ParagraphGrowthPath', className)}>
      <h2 className={classNames('ParagraphGrowthPath__title')}>
        {entity.getIn(['field_title', 0, 'value'])}
      </h2>

      <WysiwygField
        property="schema:text"
        className="ParagraphGrowthPath__text"
        html={entity.getIn(['field_text', 0, 'processed'])}
      />

      {entity.get('field_growth_path_items') ? (
        <div className="row u-margin--top--6">
          {entity.get('field_growth_path_items', List()).map((paragraph, index) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={paragraph.get('entity')}
                active={index === 0}
                className="col-12 col-sm-4"
              />
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default ParagraphGrowthPath;
